import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import packageJSON from '../../../../../package.json';
import { Divider } from '@mui/material';

import { BRAND_NAME } from '@/utils/constants';

const Footer = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          width={1}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box display={'flex'} alignItems={'center'} component="div">
            <Typography
              align={'center'}
              variant={'body1'}
              color="text.secondary"
            >
              {BRAND_NAME}
            </Typography>
            <Typography variant="body2" color={'text.secondary'} marginLeft={1}>
              v{packageJSON.version}
            </Typography>
          </Box>
          <Box display="flex" alignItems={'center'} gap={1}>
            <Typography
              align={'center'}
              variant={'subtitle2'}
              color="text.secondary"
            >
              &copy; {BRAND_NAME}, {new Date().getFullYear()}. All rights
              reserved
            </Typography>
            <Divider orientation="vertical" flexItem />
            <Link
              underline="none"
              component="a"
              href="/privacy"
              variant={'subtitle2'}
            >
              Privacy Policy
            </Link>
            <Divider orientation="vertical" flexItem />
            <Link
              underline="none"
              component="a"
              href="/tos"
              variant={'subtitle2'}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Footer;
